import React, { Component, createRef, } from 'react';
import { withTranslation, Trans } from "react-i18next";
import * as _ from "lodash";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import BusinessIcon from '@material-ui/icons/Business';
import RoomIcon from '@material-ui/icons/Room';
import Accessrating from "./Accessrating.js";
import Services from '../../api/api';
import Rating from '@material-ui/lab/Rating';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import SearchBar from "material-ui-search-bar";
import { removeSpacetoLowerCase } from '../../api/helper';
import NearMeIcon from '@material-ui/icons/NearMe';
import imgUrl from "../../assets/images/imageUrl";
import { gaLogEvent } from "../../helpers/analytics";


class MarkerList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      markerList: this.props.markerList,
      originalList: this.props.markerList,
    }
    this.handleChangeRatings = this.handleChangeRatings.bind(this);
    this.handleOnSearch = this.handleOnSearch.bind(this);
    this.cancelSearch = this.cancelSearch.bind(this);
  }
  componentDidMount() {
    gaLogEvent("Map marker", '', '');
  }
  handleChangeRatings(newValue, id) {
    this.state.markerList.forEach(element => {
      if (element.id == id) {
        element.avgRatings = newValue;
        console.log(element)
        this.submitNewRatings(element)
      }
    });
    this.setState({ markerList: this.state.markerList })
  }

  submitNewRatings(obj) {
    var param = {
      "uuid": this.props.communityuid,
      "applicantId": 1,
      "rate": obj.avgRatings,
      "nearmeId": obj.id,
      "scope": "private"
    }
    Services.saveupdatenearmerating(param).then(data => {
      try{
        if (data.data.length > 0) {

        }
      }catch(err){
        console.log("err::", err)
      }
    })
  }

  getMarkeImg(mark) {

    var iconUrl = imgUrl.mapdefult
    var classname = 'defulticon'
    if (this.props.markerType.length) {
      var filterobj = this.props.markerType.filter(obj => obj.type == mark.type)
      if (filterobj.length > 0) {
        iconUrl = filterobj[0]['iconUrl'] != "" ? filterobj[0]['iconUrl'] : imgUrl.mapdefult;
        classname = filterobj[0]['iconUrl'] != "" ? '' : 'defulticon';
      }
    }
    // var iconUrl = this.props.markerType.length > 0 ? this.props.markerType.filter(obj => obj.type == mark.type)[0]['iconUrl'] : imgUrl.hospital;
    return <img src={iconUrl} className={classname} />
  }

  handleClick(mark, param) {
    if (window.cardova) {
      if (window.cordova.plugins.launchnavigator) {
        window.cordova.plugins.launchnavigator.navigate(
          [this.props.userposition[0], this.props.userposition[1]],
          [parseFloat(mark.latitude), parseFloat(mark.longitude)],
          function () {
          },
          function (error) {
          }, {
          preferGoogleMaps: true,
          enableDebug: true
        });
      }
    } else {
      var url = "http://maps.google.com/?saddr=" + this.props.userposition[0] + "," + this.props.userposition[1] + "&daddr=" + parseFloat(mark.latitude) + "," + parseFloat(mark.longitude);
      window.open(url, "_system");
    }
  }

  handleOnSearch(e) {
    let topicList = _.cloneDeep(this.props.markerList);
    let filtered = [];
    filtered = topicList.filter(function (str) {
      return removeSpacetoLowerCase(str.name).indexOf(removeSpacetoLowerCase(e)) !== -1;
    });
    if (e.length == 0) {
      filtered = _.cloneDeep(this.props.markerList);
    }
    this.setState({
      markerList: filtered,
    });

  }

  cancelSearch(e) {
    this.setState({
      markerList: this.state.originalList,
    });
  }

  NewlineText(text) {
    return text.split('\n').map(str => <p className="nearmeDesc">{str}</p>);
  }

  render() {
    const { t } = this.props;
    var list = []
    if (this.state.markerList.length > 0) {


      //   this.state.markerList.sort(function(a, b) {
      //     return parseFloat(a.distance) - parseFloat(b.distance);
      // });

      this.state.markerList.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));

      this.state.markerList.map((mark) => {
        list.push(
          <Grid key={mark.id} container spacing={3} className="gridcontainer maplistcontainerdiv maplistingitems">
            <Grid item xs={2} className="zero text-center">
              <p className="zero hospitalicon">
                {this.getMarkeImg(mark)}
              </p>
            </Grid>
            <Grid item xs={6} className="zero">
              <p className="zero listname">{mark.name} </p>
              <p className="zero listsubtext"><b><Trans> {t("Category")} </Trans>:</b> {mark.type}</p>
              <p className="zero listsubtext"><b><Trans> {t("Contact")} </Trans>:</b> {mark.phone}</p>
              {
                mark.email && (
                  <p className="zero listsubtext"><b><Trans> {t("Email")} </Trans>:</b> {mark.email}</p>
                )
              }
              {
                mark.description && (
                  <p className="zero listsubtext"><b><Trans> {t("Description")} </Trans>:</b> {this.NewlineText(mark.description) }</p>
                )
              }
            </Grid>
            <Grid item xs={4} className="zero text-center">
              {/* <Accessrating rating={mark.avg_ratings} handleChangeRation={(newValue) => this.handleChangeRation(mark, newValue)}></Accessrating> */}
              <Box component="fieldset" mb={0} borderColor="transparent">
                <Rating
                  name={mark.id + "-simple-controlled"}
                  value={mark.avgRatings}
                  onChange={(event, newValue) => {
                    this.handleChangeRatings(newValue, mark.id)
                  }}
                />
              </Box>
              <p className="zero distancetext"><button className="nearmebutton" onClick={() => this.handleClick(mark)}><NearMeIcon></NearMeIcon></button> {mark.distance} <Trans> {t("Miles")} </Trans></p>
            </Grid>
          </Grid>
        )
      })
    } else {
      list.push(<div>{t('No Record Found')}</div>)
    }
    return (
      <div>
        <SearchBar
          placeholder={t('Search')}
          className="getaccess-searchbar"
          onChange={this.handleOnSearch}
          onCancelSearch={this.cancelSearch}
        />
        <div>{list}</div>
      </div>

    )
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    communityuid: storeState.communityId,
    langId: storeState.langId,
  };
};

const transMarkerList = withTranslation()(MarkerList);
const routeMarkerList = withRouter(transMarkerList);
export default connect(mapStateToProps, {})(routeMarkerList);